import {
  Box,
  Collapse,
  IconButton,
  Typography
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import React, { Fragment, useEffect, useState } from 'react'
import { WorkOrderBlogComponent } from '../../../components/WorkOrderBlog/WorkOrderBlog'
import { PickingRouteComponent } from '../../../components/PickingRoute/PickingRoute'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { ListSkuComponent } from './ListSkuComponent'
import { useApi } from '../../../hooks/useApi'
import { getWorkOrderSkus } from '../api'
import { State } from '../../../components/_EOS/State'

interface ViewWorkOrderRecallModalProps {
  workOrderId: number
  handleSnackbar: (message: string, success: boolean) => void
}

export const ViewWorkOrderRecallModal: React.FC<
  ViewWorkOrderRecallModalProps
> = ({ workOrderId }) => {
  const { state, callApi } =
    useApi<{ sku: string; name: string; quantity: number }[]>()
  const [accordionState, setAccordionState] = useState<{
    isProductsAccordionOpen: boolean
    isPickingRoutesAccordionOpen: boolean
  }>({ isProductsAccordionOpen: false, isPickingRoutesAccordionOpen: false })
  const classes = useStyles()

  const requestWorkOrderById = () => {
    callApi(getWorkOrderSkus(workOrderId))
  }

  useEffect(() => {
    requestWorkOrderById()
  }, [workOrderId])

  const { isProductsAccordionOpen, isPickingRoutesAccordionOpen } =
    accordionState

  return (
    <Fragment>
      <Box style={{ marginBottom: '16px' }}>
        <Typography variant='subtitle1'>Detalle de Rutas de Picking</Typography>
        <div className={classes.accordeonSummary}>
          <Typography>Rutas de Picking</Typography>
          <IconButton
            onClick={() =>
              setAccordionState((prev) => ({
                ...prev,
                isPickingRoutesAccordionOpen: !prev.isPickingRoutesAccordionOpen
              }))
            }
          >
            {isPickingRoutesAccordionOpen ? (
              <ExpandLessIcon />
            ) : (
              <ExpandMoreIcon />
            )}
          </IconButton>
        </div>
        <Collapse
          in={isPickingRoutesAccordionOpen}
          timeout='auto'
          unmountOnExit
        >
          <PickingRouteComponent workOrderId={workOrderId} />
        </Collapse>
      </Box>

      <Box style={{ marginBottom: '16px' }}>
        <div className={classes.accordeonSummary}>
          <Typography>Productos</Typography>
          <IconButton
            onClick={() =>
              setAccordionState((prev) => ({
                ...prev,
                isProductsAccordionOpen: !prev.isProductsAccordionOpen
              }))
            }
          >
            {isProductsAccordionOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </div>
        <Collapse in={isProductsAccordionOpen} timeout='auto' unmountOnExit>
          <State state={state} loadingMessage='Obteniendo skus...'>
            <ListSkuComponent skus={state.data || []} />
          </State>
        </Collapse>
      </Box>

      <Typography variant='subtitle1'>Bitácora</Typography>
      <WorkOrderBlogComponent workOrderId={workOrderId} />
    </Fragment>
  )
}

const useStyles = makeStyles(() => ({
  accordeonSummary: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, .03)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56
    },
    justifyContent: 'space-between',
    paddingLeft: '16px',
    border: '1px solid rgba(0, 0, 0, .125)',
    borderRadius: '4px',
    borderBottom: '2px solid rgba(0, 0, 0, .125)'
  }
}))
